import React, { PureComponent } from 'react'
import { setup } from 'bem-cn'
import DragHandle from '../DragHandle'
import { TASK_HEIGHT } from '../../constants'
import addDays from 'date-fns/add_days'
import BlinkingMarker from '../../../Components/BlinkingMarker';

const block = setup({
    mod: '--'
})

const b = block('CalendarTask')

class Task extends PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            inactive: false
        }
    }

    componentWillReceiveProps(newProps) {
        //Because fuck you Chrome.
        //Without this hack drag stops immediately in Chrome
        setTimeout(() => {
            !this.isCancelled && this.setState({
                inactive: newProps.inactive
            })
        }, 5)
    }

    componentWillUnmount() {
        this.isCancelled = true;
    }

    render() {
        const {
            id,
            title,
            size,
            date,
            offset,
            color,
            resizeLeft,
            resizeRight,
            startDate,
            endDate,
            disabled,
            draggable,
            resizing,
            duration,
            showMarker
        } = this.props

        const {
            inactive
        } = this.state

        return (
            <div
                className={b({
                    'left-limit': !resizeLeft,
                    'right-limit': !resizeRight,
                    disabled: disabled,
                    dragging: resizing,
                    inactive: inactive
                })}
                style={{
                    width: `calc(${size * 100}% + ${size - 1}px)`,
                    top: TASK_HEIGHT + offset + 'px'
                }}
            >
                <div
                    className={b('inner')}
                    style={{
                        borderColor: color,
                        backgroundColor: color
                    }}
                >

                    {draggable && (
                        <div className={b('drag-layer', { inactive })}>
                            {resizeLeft && (
                                <DragHandle
                                    task={id}
                                    startDate={startDate}
                                    endDate={endDate}
                                    type="start"
                                />
                            )}

                            {[...Array(size).keys()].map(i => (
                                <DragHandle
                                    task={id}
                                    key={addDays(date, i).getTime()}
                                    startDate={startDate}
                                    endDate={endDate}
                                    moveDate={addDays(date, i)}
                                    duration={duration}
                                    type="move"
                                />
                            ))}

                            {resizeRight && (
                                <DragHandle
                                    task={id}
                                    startDate={startDate}
                                    endDate={endDate}
                                    type="end"
                                />
                            )}
                        </div>
                    )}
                    <div className={b('title')}>{title}</div>
                    {showMarker && <BlinkingMarker left={45} top={90} relative={true} />}
                </div>
            </div>
        )
    }
}

export default Task
